import { TransactionSellerProvider } from '../../../../app/contexts/TransactionSellerContext'
import { SellerTransactionTable } from './components/SellerTransactionTable'

export const SellerTransactionPage = () => {
  return (
    <TransactionSellerProvider>
      <div className="w-full">
        <SellerTransactionTable />
      </div>
    </TransactionSellerProvider>
  )
}
